import { SubmissionExtractedData } from '@common/types';
import { useQuery } from '@tanstack/react-query';
import { SubmissionExtractedDataClient } from 'clients';
import { QueryKeys, SubmissionStatus } from 'enums';
import { useClient } from 'hooks/useClient';
// eslint-disable-next-line import/no-internal-modules
import { UseQueryBaseSearchOptions } from './query/types';
import { useQuerySearch } from './query/useQuery';

interface SubmissionExtractedDataQuery {
  includedSubmissionStatuses?: SubmissionStatus[];
}

export function useSearchSubmissionExtractedData(
  props?: UseQueryBaseSearchOptions<SubmissionExtractedData, SubmissionExtractedDataQuery>,
) {
  const { filter, queryOptions, enabled } = props || {};
  return useQuerySearch({
    queryKey: QueryKeys.SubmissionExtractedData,
    clientClass: SubmissionExtractedDataClient,
    filter,
    enabled,
    queryOptions: {
      ...queryOptions,
    },
  });
}

export function useRetrieveSubmissionExtractedData({ submissionId }: { submissionId?: string }) {
  const client = useClient(SubmissionExtractedDataClient);
  return useQuery<SubmissionExtractedData | null>(
    [QueryKeys.SubmissionExtractedData, submissionId],
    () => client.getBySubmissionId(submissionId!),
    { enabled: !!submissionId },
  );
}
